import script from "./EcommerceDeliveryTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceDeliveryTypes.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceDeliveryTypes.vue?vue&type=style&index=0&id=62003d61&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62003d61"]])

export default __exports__